import React from 'react';
import {
  EthDarkCircle,
  EthLightCircle,
  EthIcon,
  EthDarkIcon,
  EthBlueIcon,
  EthRedIcon,
  NRGLogoInvertedIcon,
  NRGLogoDarkIcon,
  NRGLogoLightIcon,
  NRGLogoInvertedDarkIcon,
  NRGLogoInvertedLightIcon,
  NRGLogoIcon,
  EnergiIconCustom,
  ApeChainDarkCircle,
  ApeChainLightCircle,
  ApeChainIconLight,
  ApeChainDarkIcon,
  ApeChainBlueIcon,
  ApeChainRedIcon,
  ApeChainSymbol,
  BerachainDarkCircle,
  BerachainLightCircle,
  BerachainIconLight,
  BerachainDarkIcon,
  BerachainBlueIcon,
  BerachainRedIcon,
  BerachainSymbol,
  BaseDarkCircle,
  BaseLightCircle,
  BaseSymbol,
  ShibariumDarkCircle,
  ShibariumLightCircle,
  ShibariumIconLight,
  ShibariumDarkIcon,
  ShibariumBlueIcon,
  ShibariumRedIcon,
  ShibariumSymbol,
  MonadDarkCircle,
  MonadLightCircle,
  MonadIcon,
  MonadDarkIcon,
  MonadBlueIcon,
  MonadRedIcon,
  MonadSymbol,
  BNBIcon,
  BNBYellowIcon,
  BinanceSymbol,
} from 'components/ImageComponent';
import useWalletContext from 'hooks/useWalletContext';

const CHAIN_CURRENCIES = {
  1: 'ETH',
  11155111: 'ETH',
  39797: 'NRG',
  49797: 'NRG',
  84532: 'ETH',
  8453: 'ETH', // Base uses ETH as native currency
  33139: 'APE',
  33111: 'APE',
  80094: 'BERA',
  80069: 'BERA',
  1868: 'ETH', // Soneium uses ETH
  1946: 'ETH',
  2741: 'ETH', // Abstract Mainnet uses ETH
  11124: 'ETH', // Abstract Testnet uses ETH
  109: 'SHIBARIUM_BONE', // Shibarium Mainnet
  157: 'SHIBARIUM_BONE', // Puppynet Testnet
  443: 'ETH', // TEN uses ETH
  143: 'MONAD_MON', // Monad Mainnet - uses MON
  42161: 'ETH', // Arbitrum One - uses ETH
  421614: 'ETH', // Arbitrum Sepolia - uses ETH
  56: 'BNB', // Binance Mainnet
  97: 'BNB', // Binance Testnet
};

export const CurrencyIcon = ({ props = {}, currency, type = 'default' }) => {
  const { storedChain } = useWalletContext();

  const targetCurrency = currency ?? CHAIN_CURRENCIES[storedChain];

  return {
    ETH: {
      circleDark: <EthDarkCircle {...props} />,
      circleLight: <EthLightCircle {...props} />,
      light: <EthIcon {...props} />,
      dark: <EthDarkIcon {...props} />,
      default: <EthBlueIcon {...props} />,
      current: <EthRedIcon {...props} />,
      symbol: <EthBlueIcon {...props} />,
    },
    NRG: {
      circleDark: <NRGLogoInvertedDarkIcon {...props} />,
      circleLight: <NRGLogoInvertedLightIcon {...props} />,
      light: <NRGLogoLightIcon {...props} />,
      dark: <NRGLogoDarkIcon {...props} />,
      default: <NRGLogoIcon {...props} />,
      current: <NRGLogoInvertedIcon {...props} />,
      symbol: <EnergiIconCustom {...props} />,
    },
    APE: {
      circleDark: <ApeChainDarkCircle {...props} />,
      circleLight: <ApeChainLightCircle {...props} />,
      light: <ApeChainIconLight {...props} />,
      dark: <ApeChainDarkIcon {...props} />,
      default: <ApeChainBlueIcon {...props} />,
      current: <ApeChainRedIcon {...props} />,
      symbol: <ApeChainSymbol {...props} />,
    },
    BERA: {
      circleDark: <BerachainDarkCircle {...props} />,
      circleLight: <BerachainLightCircle {...props} />,
      light: <BerachainIconLight {...props} />,
      dark: <BerachainDarkIcon {...props} />,
      default: <BerachainBlueIcon {...props} />,
      current: <BerachainRedIcon {...props} />,
      symbol: <BerachainSymbol {...props} />,
    },
    BASE: {
      circleDark: <BaseDarkCircle {...props} />,
      circleLight: <BaseLightCircle {...props} />,
      light: <BaseSymbol {...props} />,
      dark: <BaseSymbol {...props} />,
      default: <BaseSymbol {...props} />,
      current: <BaseSymbol {...props} />,
      symbol: <BaseSymbol {...props} />,
    },
    SHIBARIUM_BONE: {
      circleDark: <ShibariumDarkCircle {...props} />,
      circleLight: <ShibariumLightCircle {...props} />,
      light: <ShibariumIconLight {...props} />,
      dark: <ShibariumDarkIcon {...props} />,
      default: <ShibariumBlueIcon {...props} />,
      current: <ShibariumRedIcon {...props} />,
      symbol: <ShibariumSymbol {...props} />,
    },
    MONAD_MON: {
      circleDark: <MonadDarkCircle {...props} />,
      circleLight: <MonadLightCircle {...props} />,
      light: <MonadIcon {...props} />,
      dark: <MonadDarkIcon {...props} />,
      default: <MonadBlueIcon {...props} />,
      current: <MonadRedIcon {...props} />,
      symbol: <MonadSymbol {...props} />,
    },
    BNB: {
      circleDark: <BNBYellowIcon {...props} />,
      circleLight: <BNBYellowIcon {...props} />,
      light: <BNBIcon {...props} />,
      dark: <BNBYellowIcon {...props} />,
      default: <BNBYellowIcon {...props} />,
      current: <BNBYellowIcon {...props} />,
      symbol: <BinanceSymbol {...props} />,
    },
  }[targetCurrency]?.[type];
};
